import { render, staticRenderFns } from "./ErrorMessageParts.vue?vue&type=template&id=3899e048&scoped=true"
import script from "./ErrorMessageParts.vue?vue&type=script&lang=ts"
export * from "./ErrorMessageParts.vue?vue&type=script&lang=ts"
import style0 from "./ErrorMessageParts.vue?vue&type=style&index=0&id=3899e048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899e048",
  null
  
)

export default component.exports